import { render } from "./TopBar.vue?vue&type=template&id=0574c53c&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=0574c53c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0574c53c"

export default script